import { SERVICE_CARD_FALLBACK_IMAGE, normalizeLegacyServiceImageUrl } from '../constants/siteBranding';

/**
 * Absolute image URL for browser (e.g. uploads from API are often "/uploads/..." relative to API host).
 */
export function getApiPublicOrigin() {
  if (process.env.REACT_APP_PUBLIC_API_ORIGIN) {
    return String(process.env.REACT_APP_PUBLIC_API_ORIGIN).replace(/\/$/, '');
  }
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1';
  try {
    const u = new URL(apiUrl);
    return `${u.protocol}//${u.host}`;
  } catch {
    return '';
  }
}

/**
 * @param {string|null|undefined} url
 * @returns {string} empty string if unusable
 */
export function resolveServiceMediaUrl(url) {
  if (url == null) return '';
  const s = String(url).trim();
  if (!s) return '';
  if (/^https?:\/\//i.test(s)) return s;
  if (s.startsWith('//')) return `https:${s}`;
  if (s.startsWith('/')) {
    // Only API-hosted uploads get the API origin. CRA `public/` files (e.g. /KHP_LOGO.svg) must stay on the site origin.
    if (/^\/uploads\//i.test(s)) {
      const origin = getApiPublicOrigin();
      return origin ? `${origin}${s}` : s;
    }
    return s;
  }
  return s;
}

/** CRA `homepage` / GitHub Pages subpath: prefix relative paths with PUBLIC_URL. */
export function withCraPublicBase(pathOrUrl) {
  if (pathOrUrl == null || typeof pathOrUrl !== 'string') return pathOrUrl;
  const s = pathOrUrl.trim();
  if (!s) return s;
  if (/^https?:\/\//i.test(s)) return s;
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const p = s.startsWith('/') ? s : `/${s}`;
  return `${base}${p}`;
}

/** Service carousel / card image src: resolve API uploads, map legacy KFMS, apply CRA public base. */
export function buildServiceCardImgSrc(imageUrl) {
  const resolved = resolveServiceMediaUrl(imageUrl);
  const raw = resolved || SERVICE_CARD_FALLBACK_IMAGE;
  return withCraPublicBase(normalizeLegacyServiceImageUrl(raw));
}
